export default __webpack_public_path__ + "static/media/Roel_IMG6593.41617486.jpg";